import * as React from 'react';

export function useSidebar(setSidebarOpen: (value: boolean) => void) {
  const trigger = React.useRef<HTMLButtonElement | null>(null);
  const sidebar = React.useRef<HTMLDivElement | null>(null);

  const storedSidebarExpanded = localStorage.getItem('sidebar-expanded');
  const [sidebarExpanded, setSidebarExpanded] = React.useState<boolean>(
    storedSidebarExpanded === null ? false : storedSidebarExpanded === 'true',
  );

  React.useEffect(() => {
    const clickHandler = (event: MouseEvent) => {
      if (!sidebar.current || !trigger.current) return;
      const target = event.target as Node;
      if (sidebar.current.contains(target) || trigger.current.contains(target)) return;
      setSidebarOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  }, [setSidebarOpen, sidebar, trigger]);

  React.useEffect(() => {
    const keyHandler = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setSidebarOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  }, [setSidebarOpen]);

  React.useEffect(() => {
    localStorage.setItem('sidebar-expanded', JSON.stringify(sidebarExpanded));
    document.body.classList.toggle('sidebar-expanded', sidebarExpanded);
  }, [sidebarExpanded]);

  return { trigger, sidebar, sidebarExpanded, setSidebarExpanded };
}
